import React from "react";
import { MiModalConfirm } from "@miview/components";
import { useTheme } from "@mui/material";
import { materialCategoryService } from "@miview/api";
import { HTTP_STATUSES } from "@miview/constants";

const DeleteMaterialCategoryModal = (props) => {
  const { open, onClose, selection } = props;

  const theme = useTheme();

  const handleDelete = async () => {
    const response = await materialCategoryService.delete(selection.id);
    if (response.status === HTTP_STATUSES.OK) {
      onClose();
    }
  };

  return (
    <MiModalConfirm
      titleColor={theme.palette.primary.red}
      title={"Confirm Delete"}
      open={open}
      description={`Delete the following material category: ${selection.name}?`}
      handlePositive={handleDelete}
      handleNegative={onClose}
    ></MiModalConfirm>
  );
};

export default DeleteMaterialCategoryModal;
